import { CircularProgress } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { currencyFormatter } from "../../../../_metronic/_helpers";
import { promiseTuplify } from "../../../../_metronic/_helpers/promiseUtils";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import {
  DONATUR_URL,
  getDonaturProjectReport,
  getDonaturReportFile,
} from "../_redux/donatur/donaturCrud";

export const DonaturContributionReport = ({ donor }) => {
  const [projectReports, setProjectReports] = useState([]);
  const [totalDonation, setTotalDonation] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (donor && donor.uuid) {
      fetchProjectReport(donor.uuid);
    }
  }, [donor]);

  async function fetchProjectReport(donor_id) {
    const [res, error] = await promiseTuplify(
      getDonaturProjectReport(donor_id)
    );

    if (error) {
      return;
    }

    if (res) {
      const { data: { data = {} } = {} } = res;
      const { contributions = [], total_donation = 0 } = data;

      setProjectReports(contributions);
      setTotalDonation(total_donation);
    }
  }

  async function fetchDownloadFile() {
    if (!donor || isLoading) {
      return;
    }

    try {
      setIsLoading(true);

      const res = await getDonaturReportFile(donor.uuid);

      const url = URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.setAttribute("download", "report.pdf");

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  }

  const columns = [
    {
      text: "Nama Proyek",
      dataField: "project_name",
    },
    {
      text: "Jumlah Penerima Manfaat",
      dataField: "benefis_count",
      formatter: (cell) => {
        return <div className="text-right">{cell}</div>;
      },
    },
    {
      text: "Nominal",
      dataField: "total_amount",
      formatter: (cell) => {
        return <div className="text-right">{currencyFormatter(cell)}</div>;
      },
    },
  ];

  return (
    <Card>
      <CardHeader title="Daftar Fund Tracker">
        <CardHeaderToolbar>
          <button
            style={{ width: "200px", height: "45px" }}
            className="btn btn-primary d-flex justify-content-center align-items-center"
            onClick={fetchDownloadFile}
          >
            {isLoading ? (
              <CircularProgress size={15} color="inherit" />
            ) : (
              <span>Download Laporan</span>
            )}
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <div className="d-flex flex-column">
          <div className="d-flex justify-content-end mb-5">
            <h3 className="h3 mr-4">Total Donasi: </h3>
            <h4 className="h4">{currencyFormatter(+totalDonation)}</h4>
          </div>
          <BootstrapTable
            wrapperClasses="table-responsive"
            classes="table table-head-custom table-vertical-center overflow-hidden"
            bootstrap4
            bordered={true}
            columns={columns}
            keyField="project_uuid"
            remote
            data={projectReports}
          />
        </div>
      </CardBody>
    </Card>
  );
};
